import { render, staticRenderFns } from "./Qiehuandianpu.vue?vue&type=template&id=00b67c55&"
import script from "./Qiehuandianpu.vue?vue&type=script&lang=js&"
export * from "./Qiehuandianpu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports